import { Component } from '@angular/core';

@Component({
  selector: 'app-spinner-mini-demo',
  templateUrl: './spinner-mini-demo.component.html',
})
export class SpinnerMiniDemoComponent {}
